import { render } from "./ClinicalResearchDetailsComponent.vue?vue&type=template&id=7b849962&scoped=true"
import script from "./ClinicalResearchDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ClinicalResearchDetailsComponent.vue?vue&type=script&lang=js"

import "./ClinicalResearchDetailsComponent.vue?vue&type=style&index=0&id=7b849962&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b849962"]])

export default __exports__